import strings from 'utils/strings';

export function formateTestName(testName) {
	switch (testName) {
		case 'ORDDIKTAT':
			return strings.common.stavning;
		case 'SKRIVEHASTIGHET':
			return strings.common.skrivflyt;
		case 'ORDKJEDETESTEN':
			return strings.common.ordkedjor;
		case 'LESEPRØVEN':
			return strings.common.lasforstaelse;
		case 'TULLEORDTESTEN':
			return strings.common.nonsensord;
		case 'ORDFORSTÅELSE':
			return strings.common.ordforstaelse;
		case 'BYTTELYDTESTEN':
			return strings.common.bytaljud;
		default:
			return (
				testName.charAt(0).toUpperCase() +
				testName.slice(1).toLowerCase()
			);
	}
}
